import {
  faBook,
  faBookOpen,
  faBuilding,
  faBullhorn,
  faBus,
  faCalendarAlt,
  faChalkboardTeacher,
  faClipboardCheck,
  faClipboardList,
  faCompass,
  faFlag,
  faLayerGroup,
  faMoneyBillWave,
  faUserGraduate,
  faUserPlus,
  faFileInvoiceDollar,
  faUserGroup,
  faUsers,
} from '@fortawesome/free-solid-svg-icons';

/** Font Awesome icons for documentation modules — replaces emoji in UI. */
export const DOC_MODULE_ICONS = {
  'student-management': faUserGraduate,
  'admission-management': faUserPlus,
  'attendance-tracking': faClipboardCheck,
  'fees-management': faMoneyBillWave,
  'examination-system': faClipboardList,
  'assemblies-management': faBullhorn,
  'student-groups': faFlag,
  'timetable-management': faCalendarAlt,
  'homework-assignments': faBookOpen,
  'meetings-management': faUserGroup,
  'payroll-management': faFileInvoiceDollar,
  'parent-portal': faUsers,
  'teacher-portal': faChalkboardTeacher,
  'transport-management': faBus,
  'library-management': faBook,
  'hostel-management': faBuilding,
};

export const DOC_NAV_ICONS = {
  overview: faLayerGroup,
  'getting-started': faCompass,
};

export function getDocModuleIcon(moduleId) {
  return DOC_MODULE_ICONS[moduleId] || faLayerGroup;
}
